export const replaceAll = (src: string, dst: string) => (target: string) =>
  target.replace(new RegExp(src, "g"), dst);
